<template>
  <div>
        <div v-if="!isResultView"> <el-checkbox v-model="checkedAll" @change="changeCheckAll">全选</el-checkbox> </div> 
        <div class="list">
            <span @click="cangeItemCheck(index)" v-for="(item,index) in filteredOptions" :key="index" :class="{'checked':(selectType || []).includes(item.value)}" :v-if="!isResultView||(selectType || []).includes(item.value)" > {{item.label}} </span>
            
        </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from 'lodash'
export default {
  name: 'multipleSelect',
 props: {
    // 类型
    listOpt: {
      type: Array,
      required: true
    },
      value: {
      type: [Number, String, Array],
    },
    isResultView:{
      type:Boolean,
      default:false
    },
    // 新增：接收 worksType 属性
    worksType: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      selectType:[],
      checkedAll:false,
      options: []
    }
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        this.selectType = newVal;
      },
      immediate: true //第一次进来触发
    },
    worksType: {
      handler(newVal) {
        // worksType 变化时，重新计算 options
        this.calculateOptions();
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters(["mid", "userInfo", "evidencePaymentPrice", "vipInfo"]),
    // 计算过滤后的选项
    filteredOptions() {
      // 如果 worksType 是 16 或 17，只显示指定选项
      if (this.worksType == 16 || this.worksType == 17) {
        const allowedValues = ['5', '6', '7', '12'];
        return this.options.filter(item => allowedValues.includes(item.value.toString()));
      }
      return this.options;
    }
  },
  mounted () {
    this.$nextTick(() => {
      // this.options = _.cloneDeep(this.listOpt)
      this.calculateOptions();
    })

    if(this.selectType.length == 17){   // 同步全选勾选狂框
      this.checkedAll = true;
    }
  },
  methods: {
      calculateOptions() {
        // 深拷贝原始选项
        let clonedOptions = _.cloneDeep(this.listOpt);
        
        // 如果 worksType 是 16 或 17，过滤选项
        if (this.worksType == 16 || this.worksType == 17) {
          const allowedValues = ['5', '6', '7', '12'];
          clonedOptions = clonedOptions.filter(item => allowedValues.includes(item.value.toString()));
        }
        
        this.options = clonedOptions;
        
        // 检查是否需要更新全选状态
        this.updateCheckAllStatus();
      },
      
      updateCheckAllStatus() {
        if (this.selectType.length === this.filteredOptions.length && this.filteredOptions.length > 0) {
          this.checkedAll = true;
        } else {
          this.checkedAll = false;
        }
      },
      cangeItemCheck(idx){
          if(this.isResultView){
              return false;
          }
            const tempItemValue=this.filteredOptions[idx].value
            if(this.selectType.includes(tempItemValue)){
                this.selectType=this.selectType.filter(item=>item!=tempItemValue)
                this.checkedAll=false
            }else{
                this.selectType.push(tempItemValue)
                if(this.selectType.length==this.options.length){
                     this.checkedAll=true
                }
            }
               console.log(JSON.stringify(this.selectType))
               this.$emit('input', this.selectType);
      },
      changeCheckAll(){
          if(this.checkedAll){
            this.initAllSelected()
          }else{
              this.selectType=[]
          }
             console.log(JSON.stringify(this.selectType))
           this.$emit('input', this.selectType);
      },
        initAllSelected () {
      // 默认选择全部
        if (this.options.length > 0) {
        this.selectType = this.options.map((item) => {
          return item.value
        })
      }
    },
  }
}
</script>

<style lang='scss' scoped>
    .list{
        span{
            display: inline-block;
            padding:4px 8px;
            color:rgba(0, 18, 22,.65);
            margin-right: 8px;
            line-height: 1em;
            border:solid 1px rgba($color: #001216, $alpha: .15);
            border-radius: 2px;
            cursor: pointer;
        }
        span:hover{
            border-color:#007DFF;
            color:#007DFF;
        }
        span.checked{
            background:#007DFF;
            border-color:#007DFF;
            color:#fff;
        }
    }
</style>
